import Vue from "vue";
import {formats} from "@/modules/docuform/constants";
const { DOCUMENT, IMAGE, PDF, SPREADSHEET, SLIDESHOW, ARCHIVE, AUDIO, VIDEO } = formats;

const fileType = Vue.filter('fileTypeIcon', function (fileName) {
    const type = fileName.split('.').pop().toLowerCase();
    if (DOCUMENT.includes(type)) return '$doc_document';
    if (IMAGE.includes(type)) return '$doc_image';
    if (PDF.includes(type)) return '$doc_pdf';
    if (SPREADSHEET.includes(type)) return '$doc_sheet';
    if (SLIDESHOW.includes(type)) return '$doc_slideshow';
    if (ARCHIVE.includes(type)) return '$doc_archive';
    if (AUDIO.includes(type)) return '$doc_audio';
    if (VIDEO.includes(type)) return '$doc_video';
    return '$doc_general';
})

const simpleFileType = Vue.filter('simpleFileType', function (fileType, supportedTypes = ['document', 'image', 'pdf', 'sheet', 'slideshow', 'archive', 'audio', 'video']) {
  const type = fileType.split('/').pop().toLowerCase();
  let simpleType = '';
  if (DOCUMENT.includes(type)) simpleType = 'document';
  if (IMAGE.includes(type)) simpleType = 'image';
  if (PDF.includes(type)) simpleType = 'pdf';
  if (SPREADSHEET.includes(type)) simpleType = 'sheet';
  if (SLIDESHOW.includes(type)) simpleType = 'slideshow';
  if (ARCHIVE.includes(type)) simpleType = 'archive';
  if (AUDIO.includes(type)) simpleType = 'audio';
  if (VIDEO.includes(type)) simpleType = 'video';
  if (supportedTypes.includes(simpleType)) return simpleType;
  return 'unsupported';
})

export default {
  fileTypeIcon: fileType,
  simpleFileType
}
